import React, { useState } from "react";
import axios from 'axios';
import AddAccount from "../accounts/addAccount";

const SearchAddPage = () => {
  const [formData, setFormData] = useState({
    account: '',
    postalCode: '',
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showAccountDetails, setShowAccountDetails] = useState(false); // New state
  const [accountDetails, setAccountDetails] = useState({});
 
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
    setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
  };
 
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = {};
 
    // Frontend validation
    if (!formData.account.trim()) {
      validationErrors.account = 'Account name is required';
    }
    if (!formData.postalCode.trim()) {
      validationErrors.postalCode = 'Postal code is required';
    }
 
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
 

 
    // Submit data to backend
    setIsLoading(true);
    try {
      const response = await axios.post('https://hms.backend.hiragroupcloud.com/api/account/searchAccount/', formData);

      setAccountDetails(response.data.account); // Assuming response.data.account contains the account details
      setShowAccountDetails(true); // Show account details after successful fetch
    } catch (error) {
      console.error('Error submitting form:', error);
      setErrors({ submit: 'An error occurred. Please try again.' });
    } finally {
      setIsLoading(false);
    }
  };
 
  const handleAddClick = () => {
    setShowForm(true);
  };

  return (
    <div>
   
      <div style={{ width: '95%', margin: '0 auto', padding: "0px" }}>
        <div className="row">
       
          <div className="col-10" style={{ marginTop: "18px" }}>
  <h1>Add Account</h1>
  <h3 className="title" style={{ fontSize: '18px', marginTop: '20px',color: '#004aad', textDecoration: 'none' }}>
    Account Search
  </h3>

  <div style={{ 
    borderTop: '3px solid #004aad', 
    backgroundColor: '#f1f1f1', 
    padding: '20px', 
    marginTop: '10px', 
    borderRadius: '4px'
  }}>
    {/* Search Section */}
    <div className="search-section">
      <div className="form-group row" style={{ marginBottom: '15px' }}>
        <label style={{ fontWeight: 'bold', marginBottom: '5px' }}>
          Zip / Postal Code <span style={{ color: 'red' }}>*</span>
        </label>
        <input
          type="text"
          name="postalCode"
          className="form-control"
          value={formData.postalCode}
          onChange={handleChange}
          style={{ width: '250px', marginBottom: '10px' }}
        />
      </div>

      <div className="form-group row" style={{ marginBottom: '15px' }}>
        <label style={{ fontWeight: 'bold', marginBottom: '5px' }}>
          Account Name <span style={{ color: 'red' }}>*</span>
        </label>
        <input
          type="text"
          name="account"
          className="form-control"
          value={formData.account}
          onChange={handleChange}
          style={{ width: '250px', marginBottom: '10px' }}
        />
      </div>

      <div className="form-group row">
                  <div style={{ marginBottom: '10px' }}>
                    <button className="btn btn-primary" style={{ backgroundColor: "#004aad", borderColor: "#004aad" }} onClick={handleSubmit} disabled={isLoading}>
                      {isLoading ? 'Submitting...' : 'Search'}
                    </button>
                  </div>
    </div>
</div>
</div><br/>
              {/* Add Account Form */}
              <div className="text-section" >
                {!showForm ? (
                  <p onClick={handleAddClick} style={{ cursor: 'pointer', color: '#007bff', Color: "#004aad" }}>
                    Don't see the account you are looking for? Add it.
                  </p>
                ) : (
                  <AddAccount formData={formData} handleChange={handleChange} />
                )}
              </div>
 
              {/* Account Details Form */}
              {showAccountDetails && accountDetails && (
                <form >
                  <h3 className="title" style={{ color: 'black', borderTop: '3px solid #004aad', }}>Account Details</h3>
                  <div className="row" style={{ padding: '10px' }}>
                    <div className="col-md-4 form-group">
                      <label>Account Name</label>
                      <input
                        type="text"
                        name="account_name"
                        value={accountDetails.account_name || ''}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4 form-group">
                      <label>Account Type</label>
                      <input
                        type="text"
                        name="account_type"
                        value={accountDetails.account_type || ''}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4 form-group">
                      <label>City</label>
                      <input
                        type="text"
                        name="city"
                        value={accountDetails.city || ''}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4 form-group">
                      <label>Country</label>
                      <input
                        type="text"
                        name="country"
                        value={accountDetails.country || ''}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4 form-group">
                      <label>Email</label>
                      <input
                        type="email"
                        name="email"
                        value={accountDetails.email || ''}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4 form-group">
                      <label>Status</label>
                      <input
                        type="text"
                        name="status"
                        value={accountDetails.status || ''}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4 form-group">
                      <label>Telephone</label>
                      <input
                        type="tel"
                        name="telephone"
                        value={accountDetails.telephone || ''}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4 form-group">
                      <label>Zip</label>
                      <input
                        type="text"
                        name="zip"
                        value={accountDetails.zip || ''}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4 form-group">
                      <label>Time Zone</label>
                      <input
                        type="text"
                        name="time_zone"
                        value={accountDetails.time_zone || ''}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <br />
                </form>
              )}
 
              {errors.submit && <p style={{ color: 'red' }}>{errors.submit}</p>}
              {errors.fetch && <p style={{ color: 'red' }}>{errors.fetch}</p>}
 
        
          </div>
        </div>
      </div>
    </div>
    
  );
};

export default SearchAddPage;
